export enum contactSortingTypes {
  BIRTHDAY = 'birthday',
  NAME = 'name',
}
